import React from "react";
import {cx} from "../../lib/ClassSet";
import {Link} from "react-router";
import "./EdiMessageItem.css";

const EdiMessageItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "shipping-edi-message-list-item": true,
    "u-selected": props.selected
  })

  let url = `/shipping/orders/${data.get("orderId")}`;

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id">{data.get("id")}</td>
      <td className="field">{data.get("messageType")}</td>
      <td className="field f-orderid"><Link to={url}>{data.get("orderId")}</Link></td>
      <td className="field">{data.get("status")}</td>
      <td className="field">{data.get("updatedAt")}</td>
    </tr>
  )
}

export default EdiMessageItem;